import api from "../../api"

export const getPackages = async (data : {
    duration ?: number,
    type ?: string,
    not_owned ?: boolean,
    page ?: number,
    page_size ?: number,
    search ?: string | null,
}) => {
    const res = await api.get("packages/", { params : data })
    return res.data

}

export const buyPackage = async (data : {
    id : string,
}) => {
    const res = await api.post(`packages/${data.id}/`)
    return res.data
}

export const buyClass = async ({ id , data } : {
    id : string,
    data : {
        use_package : boolean,
    }
}) => {
    const res = await api.put(`events/${id}/join/`, data)
    return res.data
}

